import { promoteUserToOrganizationAdmin } from '@/services/api/requests/user';
import { useMutation } from '@tanstack/react-query';
import useToast from '../useToast';
import { TCustomAxiosError } from '@/services/api';

const usePromoteToOrganizationAdmin = (onSuccess?: () => void) => {
  const toast = useToast();

  const { mutate, isPending } = useMutation({
    mutationFn: async (userId: string) => {
      await promoteUserToOrganizationAdmin(userId);
    },
    onSuccess: () => {
      toast({
        title: 'User promoted to Organization Admin successfully',
        description: 'The user now has Organization Admin privileges.',
        status: 'success',
      });
      onSuccess?.();
    },
    onError: (error: TCustomAxiosError) => {
      toast(
        {
          title: 'Failed to promote user',
          description: error?.errors[0]?.message,
          status: 'error',
        },
        error,
      );
    },
  });

  return { mutate, isPending };
};

export default usePromoteToOrganizationAdmin;
